import React from "react"
import types from "prop-types"
import { useDispatch, useSelector } from "react-redux"
import { deselectCategory, isCategorySelected, selectCategory } from "reduxSlices/reportIndexSlice"
import { Checkbox } from "shared/checkboxes"
import { SidebarContentItem } from "shared/Sidebar"

const ReportIndexSidebarSolutionSectionSolutionCheckbox = ({ categoryName, categorySlug }) => {
  const dispatch = useDispatch()

  const categoryIsSelected = useSelector(isCategorySelected(categorySlug))

  const toggleReducer = categoryIsSelected ? deselectCategory : selectCategory

  const toggleSelection = () => dispatch(toggleReducer({ slug: categorySlug }))

  return (
    <SidebarContentItem onClickCapture={toggleSelection}>
      <div className="flex justify-between">
        <span>{categoryName}</span>
        <Checkbox onChange={toggleSelection} value={categoryIsSelected} />
      </div>
    </SidebarContentItem>
  )
}

ReportIndexSidebarSolutionSectionSolutionCheckbox.propTypes = {
  categoryName: types.string.isRequired,
  categorySlug: types.string.isRequired,
}

export default ReportIndexSidebarSolutionSectionSolutionCheckbox
